import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-black text-white text-center px-6">
      {/* Large 404 Heading */}
      <h1 className="text-[120px] sm:text-[160px] font-extrabold tracking-widest animate-pulse">
        404
      </h1>

      {/* Subtitle */}
      <p className="mt-4 text-xl sm:text-2xl font-light opacity-80 animate-fadeIn">
        Oops! The page you’re looking for doesn’t exist.
      </p>

      {/* Back Button */}
      <Link
        to="/"
        className="mt-8 px-6 py-3 text-lg font-medium bg-white text-black rounded-full shadow-lg hover:bg-gray-200 transition duration-300 ease-in-out"
      >
        Go Back Home
      </Link>
    </div>
  );
}
